// Google API config

export const CLIENT_ID =
  '534712866380-isvk0e4onnjaivbki8cen140nda6tnt0.apps.googleusercontent.com';
export const API_KEY = 'AIzaSyCUdTT9cc6J0bbu6pSRoxrLU5yEtehv91M';

export const DISCOVERY_DOCS = [
  'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest',
  'https://slides.googleapis.com/$discovery/rest?version=v1'
];

export const SCOPE = [
  'https://www.googleapis.com/auth/userinfo.email',
  'https://www.googleapis.com/auth/userinfo.profile',
  'https://www.googleapis.com/auth/drive',
  'https://www.googleapis.com/auth/presentations.readonly'
].join(' ');
